import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { AdditionalPaymentComponent } from "./components/additional-payment/additional-payment.component";
import { BankAccountChangeIsvComponent } from './components/bank-account-change-isv/bank-account-change-isv.component';
import { BeneficiaryChangeIspComponent } from "./components/beneficiary-change-isp/beneficiary-change-isp.component";
import { BeneficiaryChangeIsvComponent } from './components/beneficiary-change-isv/beneficiary-change-isv.component';
import { BeneficiaryFormIsvComponent } from './components/beneficiary-form-isv/beneficiary-form-isv.component';
import { BranchOfficeVariationComponent } from './components/branch-office-variation/branch-office-variation.component';
import { BranchSwitchDivestmentIntesaComponent } from "./components/branch-switch-divestment-intesa/branch-switch-divestment-intesa.component";
import { BranchSwitchInvestmentIntesaComponent } from "./components/branch-switch-investment-intesa/branch-switch-investment-intesa.component";
import { ChangeInvestmentLineIspComponent } from "./components/change-investment-line-isp/change-investment-line-isp.component";
import { ChangeInvestmentLineIsvComponent } from "./components/change-investment-line-isv/change-investment-line-isv.component";
import { ClaimNotificationIsvComponent } from './components/claim-notification-isv/claim-notification-isv.component';
import { DebitDateVariationComponent } from "./components/debit-date-variation/debit-date-variation.component";
import { DocumentChangeComponent } from './components/document-change/document-change.component';
import { ModifyReferentEmployerComponent } from "./components/modify-referent-employer/modify-referent-employer.component";
import { PartialRedeemIsvComponent } from './components/partial-redeem-isv/partial-redeem-isv.component';
import { PayerVariationComponent } from "./components/payer-variation/payer-variation.component";
import { RebalanceInvestmentsComponent } from "./components/rebalance-investments/rebalance-investments.component";
import { RedirectFundsComponent } from "./components/redirect-funds/redirect-funds.component";
import { RegistryAdjustmentComponent } from './components/registry-adjustment/registry-adjustment.component';
import { RegistryFormComponent } from './components/registry-form/registry-form.component';
import { RegistryRecapIsvComponent } from './components/registry-recap-isv/registry-recap-isv.component';
import { RegistryRecapComponent } from './components/registry-recap/registry-recap.component';
import { RegistrySearchIsvComponent } from './components/registry-search-isv/registry-search-isv.component';
import { ResidenceChangeIsvComponent } from './components/residence-change-isv/residence-change-isv.component';
import { RetirementDateVariationComponent } from "./components/retirement-date-variation/retirement-date-variation.component";
import { IsvRoutingModule } from "./isv-routing.module";
import { IsvComponent } from "./isv.component";
import { ContractorChangeIsvComponent } from "./components/contractor-change-isv/contractor-change-isv.component";
import { EmployerAgencySearchComponent } from "./components/employer-agency-search-form/employer-agency-search-form.component";
import { SpostamentoIscrittoComponent } from "./components/spostamento-iscritto/spostamento-iscritto.component";

@NgModule({
  declarations: [
    IsvComponent,
    DocumentChangeComponent,
    BeneficiaryChangeIsvComponent,
    BranchSwitchInvestmentIntesaComponent,
    BranchSwitchDivestmentIntesaComponent,
    ChangeInvestmentLineIspComponent,
    ChangeInvestmentLineIsvComponent,
    RebalanceInvestmentsComponent,
    RegistryRecapIsvComponent,
    RegistryRecapComponent,
    BranchOfficeVariationComponent,
    RegistryFormComponent,
    BeneficiaryFormIsvComponent,
    AdditionalPaymentComponent,
    ResidenceChangeIsvComponent,
    PayerVariationComponent,
    RegistryAdjustmentComponent,
    BeneficiaryChangeIspComponent,
    ClaimNotificationIsvComponent,
    RetirementDateVariationComponent,
    DebitDateVariationComponent,
    RegistrySearchIsvComponent,
    ClaimNotificationIsvComponent,
    PartialRedeemIsvComponent,
    ContractorChangeIsvComponent,
    BankAccountChangeIsvComponent,
    RedirectFundsComponent,
    SpostamentoIscrittoComponent,
    EmployerAgencySearchComponent,
    ModifyReferentEmployerComponent
  ],
  imports: [
    SharedModule,
    IsvRoutingModule,
  ]
})
export class IsvModule { }
